import { graphql } from "gql";

const INTERNAL_ADMIN_CREATE_TAG_CATEGORY_MUTATION = graphql(`
  mutation InternalAdminCreateTagCategory(
    $organizationId: ID!
    $input: AdminCreateTagCategoryInput!
  ) {
    internalAdminCreateTagCategory(
      organizationId: $organizationId
      input: $input
    ) {
      ...InternalAdminTagCategory
    }
  }
`);

export default INTERNAL_ADMIN_CREATE_TAG_CATEGORY_MUTATION;
